import React from "react";
import AboutImg1 from '../../assets/about-image-1.webp';
import AboutImg2 from '../../assets/about-image-2.webp';
import AboutImg3 from '../../assets/about-image-3.webp';
import ServiceIco1 from '../../assets/service_icon-1.svg';
import ServiceIco2 from '../../assets/service_icon-2.svg';
import ServiceIco3 from '../../assets/service_icon-3.svg';
import ServiceIco4 from '../../assets/service_icon-4.svg';

const AboutUs = () => {

    return (<>
       <section className="about_section-2">
            <div className="container">
                <div className="row justify-content-center align-items-center mb-md-5 mb-2">
                    <div className="col-md-6">
                        <div className="about_img_box">
                            <img src={AboutImg1} className='img-fluid rounded' alt='Stuck-in-an-emergency' loading='lazy'/>
                        </div>
                    </div>
                     <div className="col-md-3 d-md-block d-none">
                        <div className="about_img_box">
                            <img src={AboutImg2} className='img-fluid rounded' alt='Stuck-in-an-emergency' loading='lazy'/>
                        </div>
                    </div>
                    <div className="col-md-3 d-md-block d-none">
                        <div className="about_img_box">
                            <img src={AboutImg3} className='img-fluid rounded' alt='Stuck-in-an-emergency' loading='lazy'/>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-between align-items-center">
                    <div className="col-md-6 about-col-text text-left">
                        <h6>Immediate Roadside Help</h6>
                        <h3>Reliable Assistance Whenever and Wherever You Need It.</h3>
                        {/*<h4>Stay Updated And Ready For Any Emergency With Mechanic Hunt As Your Companion.</h4> */}
                        <p className="mb-0">When you’re stuck on the road, we understand the urgency and stress.
                            Whether it’s a tire blowout, a reefer malfunction, or you’re simply
                            looking for the nearest truck stop, Mechanic Hunt is here to provide
                            you with a seamless solution. We specialize in connecting truck drivers
                            and fleet owners with trusted, professional service providers for all
                            their truck and trailer repair needs, both in emergency situations
                            and for routine maintenance.</p>

                    </div>

                    <div className="col-md-5 about-col-text text-left">
                        <div className="about_feature_list">
                             <h5>How can we make things easier for you?</h5>
                             <ul>
                                <li>
                                 <h6>Select your service</h6>
                                 <p>Whether it's truck repairs, towing, or trailer fixes, Mechanic Hunt provides fast and reliable roadside assistance to minimize your downtime.</p>
                                </li>
                                <li>
                                 <h6>Where are you located?</h6>
                                 <p>Select your location, and Mechanic Hunt instantly links you with reliable truck repair services across the nation to keep you on the road.</p>
                                </li>
                                <li>
                                 <h6>Best matched for your needs</h6>
                                 <p>Mechanic Hunt highlights nearby repair services along with important details so you can choose the most suitable solution fast.</p>
                                </li>
                             </ul>
                        </div>
                    </div>



                </div>
            </div>
        </section>

        <section className="about_section-1">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="section-title col-md-12 mb-5 pb-3">
                        <h2>The Various Ways in Which We Strive to <br/>Cater to Your Needs</h2>
                        <p>Immediate and Dedicated Assistance to Quickly Address <br/>Your Concerns and Restore Your Mobility</p>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-3 mb-lg-0 mb-md-3">
                        <div className="about_service h-100">
                            <div className="half_circle"></div>
                            <div className="ico-high">
                                <img src={ServiceIco1} className='service_vector' alt='Serice-1'/>
                            </div>
                            <div className="about-service-text">
                            <h2>Always On, Always <br/>Ready</h2>
                            <p>Your emergencies don’t wait — and neither do we, guaranteed.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-3 mb-lg-0 mb-md-3">
                        <div className="about_service h-100">
                            <div className="half_circle"></div>
                            <div className="ico-high">
                                <img src={ServiceIco2} className='service_vector' alt='Serice-2'/>
                            </div>
                            <div className="about-service-text">
                            <h2>Prepared. Alert.<br/> Ready.</h2>
                            <p>
                            Because unexpected situations demand immediate, decisive action.
                            </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-3 mb-lg-0 mb-md-3">
                        <div className="about_service h-100">
                            <div className="half_circle"></div>
                            <div className="ico-high">
                                <img src={ServiceIco3} className='service_vector' alt='Serice-3'/>
                            </div>
                            <div className="about-service-text">
                            <h2>Safe and Reliable<br/> Service</h2>
                            <p>
                            Ensuring secure and dependable support, anytime you need it.
                            </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-3 mb-lg-0 mb-md-3">
                        <div className="about_service h-100">
                            <div className="half_circle"></div>
                            <div className="ico-high">
                                <img src={ServiceIco4} className='service_vector' alt='Serice-4'/>
                            </div>
                            <div className="about-service-text">
                            <h2>Always <br/>Dependable</h2>
                            <p>
                            Providing secure, reliable, trustworthy assistance wherever you are.
                            </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

    </>
    );
};

export default AboutUs;